import styled from "@emotion/styled"

export default styled.img`
  max-width: 100%;
  box-shadow: 0 4px 6px 0 hsla(0, 0%, 0%, 0.2);
  border-radius: 8px;
`
